export function removeNullCharacters(obj) {
    return Object.keys(obj).reduce((acc, key) => {
        acc[key] = obj[key].replace(/^\s+|\s+$/g, '');
        return acc;
    }, {});
}